import { Button } from "primereact/button";
import { TieredMenu } from "primereact/tieredmenu";
import { useRef } from "react";

const Card2 = (props) => {

  const menu = useRef(null);
  return (
    <div className={props.size}>
      <div className={props.style}>
        <div className="stats-icon stats-icon-lg">{props.icon}</div>
        <div className="stats-content">
          <div className="d-flex justify-content-between">
            <div className="stats-title mt-2">{props.title}</div>
            <div>
              <TieredMenu
                model={props.items}
                popup
                ref={menu}
                breakpoint="767px"
              />
              <Button
                text
                rounded
                outlined
                icon="pi pi-bars"
                style={props.items && props.items.length > 0 ? { color: "white" } : { color: "transparent" }}
                disabled={!(props.items && props.items.length > 0)}
                onClick={(e) => menu.current.toggle(e)}
                id={props.id} // Passar o ID do card para o botão
              />
            </div>
          </div>
          <div className="stats-number">{props.value}</div>
          <div className="stats-title pb-3">{props.desc}</div>
        </div>
      </div>
    </div>

  );
};

export default Card2;
